import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 300 },
  };

  connect() {
    this.timeout = null;
  }

  disconnect() {
    clearTimeout(this.timeout);
  }

  submit(event) {
    const form = event.currentTarget.form;

    if (!form) {
      console.error("No form found");
      return;
    }

    clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      try {
        form.requestSubmit();
      } catch (error) {
        console.error("Error during autosubmit:", error);
      }
    }, this.delayValue);
  }
}
